module.exports = __webpack_public_path__ + "media/images/app/homepage/header_woman_mobile-5544a8081bd04539d296da925d6b4b7a.webp";